import request from '@/utils/request'

/**
 * 登陆
 */
export function login(data) { return request({ url: '/api/v1/pub/admin/login', method: 'post', data }) }
export function getImportantNotify() { return request({ url: '/api/v1/admin/notify/important', method: 'get' }) }

/**
 *  获取OSS配置
 */
export function getOSS(date) { return request({ url: '/api/v1/admin/system/' + date + '/oss/settings', method: 'get' }) }

/**
 * 广告管理
 */
export function getAdvertiseList(params) { return request({ url: '/api/v1/admin/advertisement', method: 'get', params }) }
export function addAdvertise(data) { return request({ url: '/api/v1/admin/advertisement', method: 'post', data }) }
export function deleteAdvertise(advertiseId) { return request({ url: '/api/v1/admin/advertisement/' + advertiseId, method: 'delete' }) }
export function editAdvertise(aid, data) {
  return request({ url: '/api/v1/admin/advertisement/' + aid, method: 'put', data })
}

/**
 * 商品管理
 */
export function getCommodityList(params) { return request({ url: '/api/v1/admin/diamond/list', method: 'get', params }) }
export function addCommodity(data) { return request({ url: '/api/v1/admin/diamond', method: 'post', data }) }
export function editCommodity(cid, data) {
  return request({ url: '/api/v1/admin/diamond/' + cid + '/update', method: 'post', data })
}

/**
 * 每日任务管理
 */
export function getDailyTaskList(params) { return request({ url: '/api/v1/admin/system/daily/task/list', method: 'get', params }) }
export function addDailyTask(data) { return request({ url: '/api/v1/admin/system/daily/task', method: 'post', data }) }
export function editDailyTask(tid, data) {
  return request({ url: '/api/v1/admin/system/daily/task/' + tid, method: 'put', data })
}

/**
 * 用户管理
 */
export function getAllUsers(params) { return request({ url: '/api/v1/admin/user/all', method: 'get', params }) }
export function getUserList(data) { return request({ url: '/api/v1/admin/user/list', method: 'post', data }) }
export function updateUserSetting(data) {
  return request({
    url: '/api/v1/admin/user/setting',
    method: 'put',
    data
  })
}
export function addUserRemark(data) {
  return request({
    url: '/api/v1/admin/user/remark',
    method: 'post',
    data
  })
}
export function getUserRemarks(params) {
  return request({
    url: '/api/v1/admin/user/remarks',
    method: 'get',
    params
  })
}
export function getSameRealNameUsers(params) {
  return request({
    url: '/api/v1/admin/user/realname/same',
    method: 'get',
    params
  })
}
export function getSameDeviceUsers(params) {
  return request({
    url: '/api/v1/admin/user/device/same',
    method: 'get',
    params
  })
}
export function punishUser(data) {
  return request({
    url: '/api/v1/admin/audit/punishment/user',
    method: 'put',
    data
  })
}
export function getPunishmentRecords(params) {
  return request({
    url: '/api/v1/admin/audit/punishments',
    method: 'get',
    params
  })
}
export function getValidPunishmentReasons(params) {
  return request({
    url: '/api/v1/admin/audit/punishment/reason/valid',
    method: 'get',
    params
  })
}
export function updatePunishment(data) {
  return request({
    url: '/api/v1/admin/audit/punishment',
    method: 'put',
    data
  })
}
export function getChatRoomList(uid, params) {
  return request({
    url: '/api/v1/admin/contact/' + uid + '/chatrooms',
    method: 'get',
    params
  })
}
export function getChatRecords(uid, params) { return request({ url: `/api/v1/admin/contact/${uid}/chatroom/logs`, method: 'get', params }) }
export function putAward(data) {
  return request({ url: '/api/v1/admin/order/generate', method: 'post', data })
}
// 获取开启辅助功能的用户列表
export function getUserPluginList(params) { return request({ url: '/api/v1/admin/user/plugins', method: 'get', params }) }

/**
 * 审核管理管理
 */
export function getAdminAuditList(params) { return request({ url: '/api/v1/admin/audit/list', method: 'get', params }) }
export function getCloseRelationConsumptionAmount(params) {
  return request({
    url: '/api/v1/admin/contact/close/relation/consumption/amount',
    method: 'get',
    params
  })
}
export function getRelationRemarks(params) {
  return request({
    url: '/api/v1/admin/contact/relation/remarks',
    method: 'get',
    params
  })
}
export function addRelationRemark(data) {
  return request({
    url: '/api/v1/admin/contact/relation/remark',
    method: 'post',
    data
  })
}
export function getUserInfo(uid) { return request({ url: `/api/v1/admin/user/${uid}/info/detail`, method: 'get' }) }
export function updateAuditInfo(id, data) {
  return request({ url: '/api/v1/admin/audit/' + id + '/info', method: 'put', data })
}
export function resetAudit(data) {
  return request({ url: '/api/v1/admin/audit/reset', method: 'put', data })
}
export function passAuditInfoList(data) {
  return request({ url: '/api/v1/admin/audit/infoList', method: 'put', data })
}
export function getAlbumInfo(params) { return request({ url: '/api/v1/admin/user/album', method: 'get', params }) }
export function getFriendCircleList(uid, params) { return request({ url: `/api/v1/admin/contact/${uid}/friendCircles`, method: 'get', params }) }
export function getCallList(params) { return request({ url: '/api/v1/admin/contact/calls', method: 'get', params }) }
export function getAccusationList(params) { return request({ url: '/api/v1/admin/contact/accusations', method: 'get', params }) }
export function getUnderAccusationList(params) { return request({ url: '/api/v1/admin/contact/under/accusations', method: 'get', params }) }
export function getLabelList(params) { return request({ url: '/api/v1/admin/label/list', method: 'get', params }) }
export function getConsumptionInfo(id) { return request({ url: '/api/v1/admin/audit/consumption/' + id + '/info', method: 'get' }) }
export function getAuditRecalls(params) { return request({ url: '/api/v1/admin/audit/transcribes', method: 'get', params }) }
export function getAuditRecallsBySimple(params) { return request({ url: '/api/v1/admin/audit/transcribes/simple', method: 'get', params }) }
export function addCancellation(data) { return request({ url: '/api/v1/admin/audit/new', method: 'post', data }) }
export function submitTranscodeVideoJob(data) {
  return request({
    url: '/api/v1/admin/audit/transcoding',
    method: 'POST',
    data
  })
}
export function queryTranscodeJob(params) {
  return request({
    url: '/api/v1/admin/audit/transcoding',
    method: 'GET',
    params
  })
}
export function confirmUpdateTranscodingVideo(data) {
  return request({
    url: '/api/v1/admin/audit/transcoding',
    method: 'PUT',
    data
  })
}

/**
 * 管理员管理
 */
export function getAdminList(params) { return request({ url: '/api/v1/admin/list', method: 'get', params }) }
export function editAdmin(aid, data) {
  return request({ url: '/api/v1/admin/' + aid, method: 'put', data })
}
export function putAPK(data) { return request({ url: '/api/v1/admin/system/upload/apk', method: 'post', data }) }
export function getSystemInfo() { return request({ url: '/api/v1/admin/system/info', method: 'get' }) }
export function getSystemBalance() { return request({ url: '/api/v1/admin/system/balance', method: 'get' }) }
export function setMaintanece(data) { return request({ url: '/api/v1/admin/system/maintenance', method: 'post', data }) }
export function setWithdrawRate(data) { return request({ url: '/api/v1/admin/system/withdraw/rate', method: 'post', data }) }
export function setWithdrawThreshold(data) { return request({ url: '/api/v1/admin/system/withdraw/threshold', method: 'put', data }) }
export function getPromotionInfo(params) { return request({ url: '/api/v1/admin/promotion', method: 'get', params }) }
export function createPromotion(data) { return request({ url: '/api/v1/admin/promotion', method: 'post', data }) }
export function addPromotionMember(data) { return request({ url: '/api/v1/admin/promotion/member', method: 'post', data }) }
export function updatePromotion(data) { return request({ url: '/api/v1/admin/promotion/info', method: 'put', data }) }
export function getPromotionMemberEarnings(params) {
  return request({ url: '/api/v1/admin/promotion/member/earnings', method: 'get', params })
}
export function getPromotionMembers(params) {
  return request({ url: '/api/v1/admin/promotion/members', method: 'get', params })
}
export function getPromotions(params) { return request({ url: '/api/v1/admin/promotions', method: 'get', params }) }
export function updateCustomerServiceQRCode(data) { return request({ url: '/api/v1/admin/system/customer/service/qrcode', method: 'post', data }) }

/**
 * 系统货币转换比例配置信息
 * @returns
 */
export function getSystemDefaultTransform() { return request({ url: '/api/v1/admin/system/transform/default/setting', method: 'get' }) }
export function setOrUpdateTransformSetting(data) { return request({ url: '/api/v1/admin/system/transform/setting', method: 'post', data }) }
export function getTransformSettings(params) { return request({ url: '/api/v1/admin/system/transform/settings', method: 'get', params }) }
export function removeTransformSetting(data) { return request({ url: '/api/v1/admin/system/transform/setting', method: 'delete', data }) }
export function setPlatformRateStrategy(data) { return request({ url: '/api/v1/admin/system/platform/strategy', method: 'post', data }) }
export function getPlatformRateStrateies(params) { return request({ url: '/api/v1/admin/system/platform/strategies', method: 'get', params }) }
export function delPlatformRateStrategy(data) { return request({ url: '/api/v1/admin/system/platform/strategies', method: 'delete', data }) }


/**
 * 规则管理
 */
export function getMatchRuleList(params) { return request({ url: '/api/v1/admin/strategy/rules', method: 'get', params }) }
export function addMatchRule(data) { return request({ url: '/api/v1/admin/strategy/rule', method: 'post', data }) }
export function editMatchRule(mrId, data) {
  return request({ url: '/api/v1/admin/strategy/rule/' + mrId, method: 'put', data })
}
export function setRegisterRewardRule(data) { return request({ url: '/api/v1/admin/system/register/reward/rule', method: 'post', data }) }
export function getRegisterRewardRules(params) { return request({ url: '/api/v1/admin/system/register/reward/rules', method: 'get', params }) }
export function delRegisterRewardRules(data) { return request({ url: '/api/v1/admin/system/register/reward/rules', method: 'delete', data }) }

/**
 * 策略管理
 */
export function getStrategyList(params) { return request({ url: '/api/v1/admin/strategy/list', method: 'get', params }) }
export function addStrategy(data) { return request({ url: '/api/v1/admin/strategy', method: 'post', data }) }
export function editStrategy(sid, data) {
  return request({ url: '/api/v1/admin/strategy/' + sid, method: 'put', data })
}

/**
 * 统计管理
 */
export function getAgeList(params) { return request({ url: '/api/v1/admin/statistics/age', method: 'get', params }) }
export function getAliveList(params) { return request({ url: '/api/v1/admin/statistics/alive', method: 'get', params }) }
export function getGiftChat(params) { return request({ url: '/api/v1/admin/statistics/consumption', method: 'get', params }) }
export function getOnlineList(params) { return request({ url: '/api/v1/admin/statistics/online', method: 'get', params }) }
export function getActivityList(params) { return request({ url: '/api/v1/admin/statistics/activity/female', method: 'get', params }) }
export function getIncomeChat(params) { return request({ url: '/api/v1/admin/statistics/income', method: 'get', params }) }
export function getChannelFlowList(params) { return request({ url: '/api/v1/admin/statistics/channel', method: 'get', params }) }
export function getCityList(params) { return request({ url: '/api/v1/admin/statistics/city', method: 'get', params }) }

/**
 * 订单管理 — 获取用户订单列表
 * @param {*} data
 */
export function getUserOrders(params) { return request({ url: '/api/v1/admin/user/orders', method: 'get', params }) }
export function getUserObj(uid) { return request({ url: `/api/v1/admin/user/${uid}/info`, method: 'get' }) }
export function batchAuditTransfer(data) { return request({ url: '/api/v1/admin/order/' + data.id + '/auditing', method: 'post', data }) }
export function getOrdersForUserInfo(params) {
  return request({
    url: '/api/v1/admin/order/user/detail',
    method: 'get',
    params
  })
}
export function getWechatRechargeOrders(params) {
  return request({
    url: '/api/v1/admin/order/wechat/mer',
    method: 'get',
    params
  })
}
export function getOrdersWhichAdminSent(params) { return request({ url: '/api/v1/admin/order/has/sent', method: 'get', params }) }
export function getEarningsFromMale(params) { return request({ url: '/api/v1/admin/order/relation/earnings', method: 'get', params }) }
export function getWithdrawChannels() { return request({ url: '/api/v1/admin/order/withdraw/channels', method: 'get' }) }
export function getUserBalanceTransfers(params) { return request({ url: '/api/v1/admin/order/users/balance/transfers', method: 'get', params }) }
export function delUserBalanceTransfers(data) { return request({ url: '/api/v1/admin/order/users/balance/transfers', method: 'delete', data }) }
export function rerunUserBalanceTransfers(data) { return request({ url: '/api/v1/admin/order/users/balance/transfer', method: 'post', data }) }
export function getPendingOrderInQueue(params) { return request({ url: '/api/v1/admin/order/pending/in/queue', method: 'get', params }) }
export function clearPendingOrderInQueue(data) { return request({ url: '/api/v1/admin/order/pending/in/queue', method: 'delete', data }) }
export function resetStatusOfWithdrawQueue() { return request({ url: 'api/v1/admin/order/reset/status/queue', method: 'post' }) }
export function getRecentIncomeByChat(params) { return request({ url: '/api/v1/admin/order/income/chat/recent', method: 'get', params }) }

/**
 * 消息管理
 */
export function getBlackList(params) { return request({ url: '/api/v1/admin/contact/blackList', method: 'get', params }) }
// 系统消息列表
export function getSystemInfoList(params) { return request({ url: '/api/v1/admin/system/message', method: 'get', params }) }
export function getChatRecordBySystemUserAndUser(params) { return request({ url: `/api/v1/admin/system/message/record`, method: 'get', params }) }
export function replyUserFeedback(data) { return request({ url: '/api/v1/admin/system/user/feedback/reply', method: 'post', data }) }
export function finishUserFeedback(data) { return request({ url: '/api/v1/admin/system/user/feedback/finish', method: 'put', data }) }
export function addSystemInfo(data) { return request({ url: '/api/v1/admin/system/message', method: 'post', data }) }
export function deleteSystemInfo(systemInfoId) { return request({ url: '/api/v1/admin/system/message/' + systemInfoId, method: 'delete' }) }
export function editSystemInfo(id, data) {
  return request({ url: '/api/v1/admin/system/message/' + id, method: 'put', data })
}
export function getWhiteIpList() { return request({ url: '/api/v1/admin/system/white/ips', method: 'get' }) }
export function updateWhiteIpInfo(data) { return request({ url: '/api/v1/admin/system/white/ip', method: 'post', data }) }
export function toWithdraw(data) { return request({ url: '/api/v1/admin/system/to/withdraw', method: 'post', data }) }

/**
 * 礼物管理
 */
// export function getGiftList(params) { return request({ url: '/api/v1/admin/gift/list', method: 'get', params }) }
export function addGift(data) { return request({ url: '/api/v1/admin/gift', method: 'post', data }) }
export function editGift(data) {
  return request({ url: '/api/v1/admin/gift/' + data.id, method: 'put', data })
}
export function setDefaultVal(data) {
  return request({ url: '/api/v1/admin/gift/default/val', method: 'post', data })
}
export function getDefaultVals() {
  return request({ url: '/api/v1/admin/gift/default/vals', method: 'get' })
}
export function delDefaultVal(data) {
  return request({ url: '/api/v1/admin/gift/default/val', method: 'delete', data })
}
export function sentGift2Backpack(data) {
  return request({ url: '/api/v1/admin/gift/backpack/sent', method: 'post', data })
}
export function getSortGiftList(params) { return request({ url: '/api/v1/admin/gift/sort/list', method: 'get', params }) }
export function sortGift(data) { return request({ url: '/api/v1/admin/gift/sort', method: 'post', data }) }

/**
 * 渠道管理
 */
export function getChannelList(params) { return request({ url: '/api/v1/admin/channel/list', method: 'get', params }) }
export function addChannel(data) { return request({ url: '/api/v1/admin/channel/new', method: 'post', data }) }
export function editChannel(id, data) {
  return request({ url: '/api/v1/admin/channel/' + id, method: 'put', data })
}
export function delChannels(data) { return request({ url: '/api/v1/admin/channel/batch', method: 'delete', data }) }
export function getChannelsByShort(params) { return request({ url: '/api/v1/admin/channel/short', method: 'get', params }) }
export function addNewAgent(data) { return request({ url: '/api/v1/admin/channel/agent', method: 'post', data }) }
export function getAgentsForShort(params) { return request({ url: '/api/v1/admin/channel/agents/short', method: 'get', params }) }
export function getAgents(params) { return request({ url: '/api/v1/admin/channel/agents', method: 'get', params }) }
export function delAgents(data) { return request({ url: '/api/v1/admin/channel/agent/batch', method: 'delete', data }) }
export function getLastPlanName() { return request({ url: '/api/v1/admin/channel/last/plan', method: 'get' }) }
export function editAgent(id, data) {
  return request({ url: '/api/v1/admin/channel/agent/' + id, method: 'put', data })
}

/**
 * 邀请记录以及配置
 */
export function getInvitationDefaultSetting() { return request({ url: '/api/v1/admin/invitation/default', method: 'get' }) }
export function setInvitationDefaultSetting(data) { return request({ url: '/api/v1/admin/invitation/default', method: 'post', data }) }
export function getInvitations(params) { return request({ url: '/api/v1/admin/invitation/list', method: 'get', params }) }
export function newInvitation(data) { return request({ url: '/api/v1/admin/invitation/new', method: 'post', data }) }
export function removeInvitations(data) { return request({ url: '/api/v1/admin/invitation/batch', method: 'delete', data }) }
export function updateInvitation(id, data) { return request({ url: `/api/v1/admin/invitation/${id}`, method: 'put', data }) }
export function getInvitationWithEarnings(params) {
  return request({
    url: '/api/v1/admin/invitation/list/earnings',
    method: 'get',
    params
  })
}

/**
 * 系统弹窗配置
 */
export function getSystemPopups() { return request({ url: '/api/v1/admin/system/popups', method: 'get' }) }
export function addSystemPopup(data) { return request({ url: '/api/v1/admin/system/popup', method: 'post', data }) }
export function delSystemPopup(data) { return request({ url: '/api/v1/admin/system/popup', method: 'delete', data }) }
export function updateSystemPopup(data) { return request({ url: '/api/v1/admin/system/popup', method: 'put', data }) }

/**
 * 系统配置视频卡
 */
export function generateVideoCard(data) { return request({ url: '/api/v1/admin/contact/card/video', method: 'post', data }) }
export function disableOrEnableVideoCard(data) { return request({ url: '/api/v1/admin/contact/card/video', method: 'put', data }) }
export function getVideoCards(params) { return request({ url: '/api/v1/admin/contact/card/video/list', method: 'get', params }) }
export function removeVideoCards(data) { return request({ url: '/api/v1/admin/contact/card/video', method: 'delete', data }) }
/**
 * 系统配置免费消息卡
 */
export function generateMsgCard(data) { return request({ url: '/api/v1/admin/contact/card/msg', method: 'post', data }) }
export function disableOrEnableMsgCard(data) { return request({ url: '/api/v1/admin/contact/card/msg', method: 'put', data }) }
export function getMsgCards(params) { return request({ url: '/api/v1/admin/contact/card/msg/list', method: 'get', params }) }
export function removeMsgCards(data) { return request({ url: '/api/v1/admin/contact/card/msg', method: 'delete', data }) }
export function updateFreeMsgLimit(data) { return request({ url: '/api/v1/admin/system/free-msg-card/limit', method: 'put', data }) }
export function getUsersWhichHasCard(params) { return request({ url: `/api/v1/admin/contact/card/${params.type}/users`, method: 'get', params }) }
export function removeUserCards(data) { return request({ url: `/api/v1/admin/contact/card/${data.type}/users`, method: 'delete', data }) }

export function getUserAttentionLikeList(params) { return request({ url: '/api/v1/admin/contact/attention/like', method: 'get', params }) }

/**
 * 女用户黑白名单
 */
export function addUserInSpecialList(data) {
  return request({
    url: '/api/v1/admin/user/special/list',
    method: 'post',
    data
  })
}
export function getSpecialUsers(params) {
  return request({
    url: '/api/v1/admin/user/special/lists',
    method: 'get',
    params
  })
}
export function updateUserSpecialStatus(data) {
  return request({
    url: '/api/v1/admin/user/special/status',
    method: 'put',
    data
  })
}
export function addSupportNewFemale(data) {
  return request({
    url: '/api/v1/admin/user/special/support/new',
    method: 'post',
    data
  })
}
export function getSupportNewFemaleList(params) {
  return request({
    url: '/api/v1/admin/user/special/support/new/list',
    method: 'get',
    params
  })
}
export function relieveSupportNewFemale(data) {
  return request({
    url: '/api/v1/admin/user/special/support/new/status',
    method: 'put',
    data
  })
}

/**
 * 用户标签
 */
export function getTaglist(params) {
  return request({
    url: '/api/v1/admin/user/tags',
    method: 'get',
    params
  })
}
export function addNewTag(data) {
  return request({
    url: '/api/v1/admin/user/tag',
    method: 'post',
    data
  })
}
export function bindUserTag(data) {
  return request({
    url: '/api/v1/admin/user/tag/relation',
    method: 'post',
    data
  })
}
export function unbindUserTag(data) {
  return request({
    url: '/api/v1/admin/user/tag',
    method: 'delete',
    data
  })
}
export function getUserTags(params) {
  return request({
    url: '/api/v1/admin/user/tag/relations',
    method: 'get',
    params
  })
}
export function getUserTagHistory(params) {
  return request({
    url: '/api/v1/admin/user/tag/relation/history',
    method: 'get',
    params
  })
}
export function getThumbnailTags() {
  return request({
    url: '/api/v1/admin/user/tags/thumbnail',
    method: 'get'
  })
}
export function getUsersForBatchTag(data) {
  return request({
    url: '/api/v1/admin/user/list/mjcode',
    method: 'post',
    data
  })
}
export function deleteTag(data) {
  return request({
    url: '/api/v1/admin/user/tag/status',
    method: 'put',
    data
  })
}

/**
 * 微信号申请审核管理
 */
export function getUserWechatApplies(params) { return request({ url: '/api/v1/admin/audit/wechat/list', method: 'get', params }) }
export function handleUserWechatApply(data) { return request({ url: '/api/v1/admin/audit/wechat', method: 'post', data }) }
export function updateUserWechatIntimacy(data) { return request({ url: '/api/v1/admin/audit/wechat/intimacy', method: 'post', data }) }

/*
 * 活动管理
 */
export function setActivity(data) { return request({ url: '/api/v1/admin/activity', method: 'post', data }) }
export function getActivitys(params) { return request({ url: '/api/v1/admin/activity', method: 'get', params }) }
export function disableOrEnableActivity(data) { return request({ url: '/api/v1/admin/activity/' + data.id, method: 'put', data }) }
export function getActivityWinRecords(params) { return request({ url: '/api/v1/admin/activity/win/records', method: 'get', params }) }
export function setActivityPrice(data) { return request({ url: '/api/v1/admin/activity/price', method: 'post', data }) }
export function getActivityPrices(params) { return request({ url: '/api/v1/admin/activity/prices', method: 'get', params }) }
export function delActivityPrices(data) { return request({ url: '/api/v1/admin/activity/prices', method: 'delete', data }) }
export function setActivityReward(data) { return request({ url: '/api/v1/admin/activity/reward', method: 'post', data }) }
export function getActivityRewards(params) { return request({ url: '/api/v1/admin/activity/rewards', method: 'get', params }) }
export function delActivityRewards(data) { return request({ url: '/api/v1/admin/activity/rewards', method: 'delete', data }) }
export function setActivityLove(data) { return request({ url: '/api/v1/admin/activity/love', method: 'post', data }) }
export function getActivityLoves(params) { return request({ url: '/api/v1/admin/activity/loves', method: 'get', params }) }
export function delActivityLoves(data) { return request({ url: '/api/v1/admin/activity/loves', method: 'delete', data }) }
export function getActivityCheckPointRecords(params) { return request({ url: '/api/v1/admin/activity/love/cps', method: 'get', params }) }

/*
 * 短信归因录入
 */
export function addLaunchAttributionPhone(data) { return request({ url: '/api/v1/admin/channel/sms/add', method: 'post', data }) }
export function getLaunchAttributionPhones(params) { return request({ url: '/api/v1/admin/channel/sms/list', method: 'get', params }) }
export function delLaunchAttributionPhones(data) { return request({ url: '/api/v1/admin/channel/sms/batch', method: 'delete', data }) }

/**
 * 管理申请单
 */
export function getApplyRecords(data) {
  return request({
    url: '/api/v1/admin/apply/records',
    method: 'post',
    data
  })
}
export function getApplyRecordTypes(params) {
  return request({
    url: '/api/v1/admin/apply/record/type',
    method: 'get',
    params
  })
}
export function addApply(data) {
  return request({
    url: '/api/v1/admin/apply/record',
    method: 'post',
    data
  })
}
export function handleApply(data) {
  return request({
    url: '/api/v1/admin/apply/record',
    method: 'put',
    data
  })
}
export function deleteLullCloseRelation(data) {
  return request({
    url: '/api/v1/admin/contact/relation/lull',
    method: 'delete',
    data
  })
}

/**
 * 工作台相关
 */
export function getAdminWorkStatus(params) {
  return request({
    url: '/api/v1/admin/work/status',
    method: 'get',
    params
  })
}
export function updateAdminWorkStatus(data) {
  return request({
    url: '/api/v1/admin/work/status',
    method: 'put',
    data
  })
}
export function getPatrolUsers(params) {
  return request({
    url: '/api/v1/admin/work/patrol/users',
    method: 'get',
    params
  })
}
export function getPatrolReportList(params) {
  return request({
    url: '/api/v1/admin/work/patrol/reports',
    method: 'get',
    params
  })
}
export function passPatrol(data) {
  return request({
    url: '/api/v1/admin/work/patrol/pass',
    method: 'put',
    data
  })
}
export function transferPatrol(data) {
  return request({
    url: '/api/v1/admin/work/patrol/transfer',
    method: 'put',
    data
  })
}
export function reportPatrol(data) {
  return request({
    url: '/api/v1/admin/work/patrol/report',
    method: 'post',
    data
  })
}
export function checkReportRepeat(data) {
  return request({
    url: '/api/v1/admin/work/patrol/report/check',
    method: 'post',
    data
  })
}
export function updatePatrolReport(data) {
  return request({
    url: '/api/v1/admin/work/patrol/report',
    method: 'put',
    data
  })
}
export function getPatrolWorkStatistics(params) {
  return request({
    url: '/api/v1/admin/work/patrol/statistics',
    method: 'get',
    params
  })
}
export function getPatrolStatisticsSurvey(params) {
  return request({
    url: '/api/v1/admin/work/patrol/statistics/survey',
    method: 'get',
    params
  })
}
export function getRiskTagFluctuation(params) {
  return request({
    url: '/api/v1/admin/work/tag/fluctuation/risk',
    method: 'get',
    params
  })
}

export function getAdminWorkAudits(params) {
  return request({
    url: '/api/v1/admin/work/audits',
    method: 'get',
    params
  })
}
export function getAuditListTypeCount(params) {
  return request({
    url: '/api/v1/admin/work/audit/type/count',
    method: 'get',
    params
  })
}
export function getAuditStatistics(params) {
  return request({
    url: '/api/v1/admin/work/audit/statistics',
    method: 'get',
    params
  })
}
export function getAuditStatisticsReview(params) {
  return request({
    url: '/api/v1/admin/work/audit/statistics/review',
    method: 'get',
    params
  })
}
export function getNeedStatisticalAuditTypes(params) {
  return request({
    url: '/api/v1/admin/work/audit/review/type',
    method: 'get',
    params
  })
}
export function getAdminWorkRejectReasons(params) {
  return request({
    url: '/api/v1/admin/work/reason/reject',
    method: 'get',
    params
  })
}
export function addAdminWorkRejectReasons(data) {
  return request({
    url: '/api/v1/admin/work/reason/reject',
    method: 'post',
    data
  })
}
export function updateAdminWorkRejectReason(data) {
  return request({
    url: '/api/v1/admin/work/reason',
    method: 'put',
    data
  })
}

// 获取来源列表
export function getAppOrigins() {
  return request({
    url: '/api/v1/admin/user/app/origins',
    method: 'get'
  })
}

export function getAccostCardAmount(params) {
  return request({
    url: '/api/v1/admin/contact/accost/card/amount',
    method: 'get',
    params
  })
}

export function modifyAccostCardAmount(data) {
  return request({
    url: '/api/v1/admin/contact/accost/card/amount',
    method: 'put',
    data
  })
}

export function getFateMatchHeat(params) {
  return request({
    url: '/api/v1/admin/contact/fate/match/heat',
    method: 'get',
    params
  })
}

export function modifyFateMatchHeat(data) {
  return request({
    url: '/api/v1/admin/contact/fate/match/heat',
    method: 'put',
    data
  })
}

export function getFateHeatList(params) {
  return request({
    url: '/api/v1/admin/contact/fate/heat/list',
    method: 'get',
    params
  })
}

export function getAccostCardList(params) {
  return request({
    url: '/api/v1/admin/contact/accost/card/list',
    method: 'get',
    params
  })
}

export function getInventoryList(params) { return request({ url: '/api/v1/inventory', method: 'get', params }) }
export function createInventory(data) { return request({ url: '/api/v1/inventory', method: 'post', data }) }
export function lookInventoryMay(data) { return request({ url: `/api/v1/inventory/look/many`, method: 'put', data }) }
export function updateInventory(id, data) { return request({ url: `/api/v1/inventory/${id}`, method: 'put', data }) }
export function tidyInventory(id, data) { return request({ url: `/api/v1/inventory/tidy/${id}`, method: 'post', data }) }
export function deleteInventory(id) { return request({ url: `/api/v1/inventory/${id}`, method: 'delete' }) }

export function getInventoryInventoryList(params) { return request({ url: '/api/v1/stash/inventory/inventory', method: 'get', params }) }
export function tidyInventoryInventory(id, data) { return request({ url: `/api/v1/stash/inventory/tidy/${id}`, method: 'post', data }) }
export function tidyMonthInventory(id, data) { return request({ url: `/api/v1/stash/inventory/monthHand/${id}`, method: 'get', data }) }
export function getStashInventoryList(params) { return request({ url: '/api/v1/stash/inventory', method: 'get', params }) }
export function getMonthInventoryList(params) { return request({ url: '/api/v1/stash/inventory/group', method: 'get', params }) }
export function createStashInventory(data) { return request({ url: '/api/v1/stash/inventory', method: 'post', data }) }
export function lookStashInventoryMay(data) { return request({ url: `/api/v1/stash/inventory/look/many`, method: 'put', data }) }
export function updateStashInventory(id, data) { return request({ url: `/api/v1/stash/inventory/${id}`, method: 'put', data }) }
export function deleteStashInventory(id) { return request({ url: `/api/v1/stash/inventory/${id}`, method: 'delete' }) }

export function getInventoryTaskList(params) { return request({ url: '/api/v1/inventoryTask', method: 'get', params }) }
export function createInventoryTask(data) { return request({ url: '/api/v1/inventoryTask', method: 'post', data }) }
export function updateInventoryTask(id, data) { return request({ url: `/api/v1/inventoryTask/${id}`, method: 'put', data }) }
export function deleteInventoryTask(id) { return request({ url: `/api/v1/inventoryTask/${id}`, method: 'delete' }) }

export function getGoodsList(params) { return request({ url: '/api/v1/goods', method: 'get', params }) }
export function getGoodsListByActivity(params) { return request({ url: '/api/v1/goods/byActivity', method: 'get', params }) }
export function createGoods(data) { return request({ url: '/api/v1/goods', method: 'post', data }) }
export function updateGoods(id, data) { return request({ url: `/api/v1/goods/${id}`, method: 'put', data }) }
export function deleteGoods(id) { return request({ url: `/api/v1/goods/${id}`, method: 'delete' }) }

export function getGoodsArrList(params) { return request({ url: '/api/v1/goodsArr', method: 'get', params }) }
export function createGoodsArr(data) { return request({ url: '/api/v1/goodsArr', method: 'post', data }) }
export function updateGoodsArr(id, data) { return request({ url: `/api/v1/goodsArr/${id}`, method: 'put', data }) }
export function deleteGoodsArr(id) { return request({ url: `/api/v1/goodsArr/${id}`, method: 'delete' }) }

export function getGoodsPlayList(params) { return request({ url: '/api/v1/goodsPlay', method: 'get', params }) }
export function getGoodsPlayGoodsList(params) { return request({ url: '/api/v1/goodsPlay/goods', method: 'get', params }) }
export function getGoodsPlayListByActivity(params) { return request({ url: '/api/v1/goodsPlay/byActivity', method: 'get', params }) }
export function createGoodsPlay(data) { return request({ url: '/api/v1/goodsPlay', method: 'post', data }) }
export function updateGoodsPlay(id, data) { return request({ url: `/api/v1/goodsPlay/${id}`, method: 'put', data }) }
export function deleteGoodsPlay(id) { return request({ url: `/api/v1/goodsPlay/${id}`, method: 'delete' }) }

export function getGoodsPlayArrList(params) { return request({ url: '/api/v1/goodsPlayArr', method: 'get', params }) }
export function createGoodsPlayArr(data) { return request({ url: '/api/v1/goodsPlayArr', method: 'post', data }) }
export function updateGoodsPlayArr(id, data) { return request({ url: `/api/v1/goodsPlayArr/${id}`, method: 'put', data }) }
export function deleteGoodsPlayArr(id) { return request({ url: `/api/v1/goodsPlayArr/${id}`, method: 'delete' }) }

export function getGoodsSupplierList(params) { return request({ url: '/api/v1/goods/supplier', method: 'get', params }) }
export function createGoodsSupplier(data) { return request({ url: '/api/v1/goods/supplier', method: 'post', data }) }
export function updateGoodsSupplier(id, data) { return request({ url: `/api/v1/goods/supplier/${id}`, method: 'put', data }) }
export function deleteGoodsSupplier(id) { return request({ url: `/api/v1/goods/supplier/${id}`, method: 'delete' }) }

export function getGoodsWarehousList(params) { return request({ url: '/api/v1/goods/warehous', method: 'get', params }) }
export function createGoodsWarehous(data) { return request({ url: '/api/v1/goods/warehous', method: 'post', data }) }
export function updateGoodsWarehous(id, data) { return request({ url: `/api/v1/goods/warehous/${id}`, method: 'put', data }) }
export function deleteGoodsWarehous(id) { return request({ url: `/api/v1/goods/warehous/${id}`, method: 'delete' }) }

export function getGoodsDeliveryList(params) { return request({ url: '/api/v1/goods/delivery', method: 'get', params }) }
export function createGoodsDelivery(data) { return request({ url: '/api/v1/goods/delivery', method: 'post', data }) }
export function updateGoodsDelivery(id, data) { return request({ url: `/api/v1/goods/delivery/${id}`, method: 'put', data }) }
export function deleteGoodsDelivery(id) { return request({ url: `/api/v1/goods/delivery/${id}`, method: 'delete' }) }

export function getGoodsReturnList(params) { return request({ url: '/api/v1/goods/return', method: 'get', params }) }
export function createGoodsReturn(data) { return request({ url: '/api/v1/goods/return', method: 'post', data }) }
export function updateGoodsReturn(id, data) { return request({ url: `/api/v1/goods/return/${id}`, method: 'put', data }) }
export function deleteGoodsReturn(id) { return request({ url: `/api/v1/goods/return/${id}`, method: 'delete' }) }

export function getSchedulingList(params) { return request({ url: '/api/v1/scheduling', method: 'get', params }) }
export function createScheduling(data) { return request({ url: '/api/v1/scheduling', method: 'post', data }) }
export function updateScheduling(id, data) { return request({ url: `/api/v1/scheduling/${id}`, method: 'put', data }) }
export function deleteScheduling(id) { return request({ url: `/api/v1/scheduling/${id}`, method: 'delete' }) }

export function getReturnFactoryList(params) { return request({ url: '/api/v1/returnFactory', method: 'get', params }) }
export function createReturnFactory(data) { return request({ url: '/api/v1/returnFactory', method: 'post', data }) }
export function updateReturnFactory(id, data) { return request({ url: `/api/v1/returnFactory/${id}`, method: 'put', data }) }
export function deleteReturnFactory(id) { return request({ url: `/api/v1/returnFactory/${id}`, method: 'delete' }) }

export function getGoodsExchangeList(params) { return request({ url: '/api/v1/goods/exchange', method: 'get', params }) }
export function createGoodsExchange(data) { return request({ url: '/api/v1/goods/exchange', method: 'post', data }) }
export function updateGoodsExchange(id, data) { return request({ url: `/api/v1/goods/exchange/${id}`, method: 'put', data }) }
export function deleteGoodsExchange(id) { return request({ url: `/api/v1/goods/exchange/${id}`, method: 'delete' }) }

export function getGoodsOrderList(params) { return request({ url: '/api/v1/goods/order', method: 'get', params }) }
export function createGoodsOrder(data) { return request({ url: '/api/v1/goods/order', method: 'post', data }) }
export function updateGoodsOrder(id, data) { return request({ url: `/api/v1/goods/order/${id}`, method: 'put', data }) }
export function deleteGoodsOrder(id) { return request({ url: `/api/v1/goods/order/${id}`, method: 'delete' }) }
export function getGoodsOrderWaitList(params) { return request({ url: '/api/v1/goods/order/wait', method: 'get', params }) }

export function getGoodsActivityList(params) { return request({ url: '/api/v1/goods/activity', method: 'get', params }) }
export function createGoodsActivity(data) { return request({ url: '/api/v1/goods/activity', method: 'post', data }) }
export function updateGoodsActivity(id, data) { return request({ url: `/api/v1/goods/activity/${id}`, method: 'put', data }) }
export function deleteGoodsActivity(id) { return request({ url: `/api/v1/goods/activity/${id}`, method: 'delete' }) }

export function getGoodsGameplayList(params) { return request({ url: '/api/v1/goods/activity/gameplay', method: 'get', params }) }
export function createGoodsGameplay(data) { return request({ url: '/api/v1/goods/activity/gameplay', method: 'post', data }) }
export function updateGoodsGameplay(id, data) { return request({ url: `/api/v1/goods/activity/gameplay/${id}`, method: 'put', data }) }
export function deleteGoodsGameplay(id) { return request({ url: `/api/v1/goods/activity/gameplay/${id}`, method: 'delete' }) }

export function getGoodsOrderReturnList(params) { return request({ url: '/api/v1/goods/order/return', method: 'get', params }) }
export function createGoodsOrderReturn(data) { return request({ url: '/api/v1/goods/order/return', method: 'post', data }) }
export function updateGoodsOrderReturn(id, data) { return request({ url: `/api/v1/goods/order/return/${id}`, method: 'put', data }) }
export function deleteGoodsOrderReturn(id) { return request({ url: `/api/v1/goods/order/return/${id}`, method: 'delete' }) }

export function getSaleChannelList(params) { return request({ url: '/api/v1/sale/channel', method: 'get', params }) }
export function createSaleChannel(data) { return request({ url: '/api/v1/sale/channel', method: 'post', data }) }
export function updateSaleChannel(id, data) { return request({ url: `/api/v1/sale/channel/${id}`, method: 'put', data }) }
export function deleteSaleChannel(id) { return request({ url: `/api/v1/sale/channel/${id}`, method: 'delete' }) }

export function getSaleAnchorList(params) { return request({ url: '/api/v1/sale/anchor', method: 'get', params }) }
export function getSaleAnchorOperatorList(params) { return request({ url: '/api/v1/sale/anchor/operator', method: 'get', params }) }
export function createSaleAnchor(data) { return request({ url: '/api/v1/sale/anchor', method: 'post', data }) }
export function updateSaleAnchor(id, data) { return request({ url: `/api/v1/sale/anchor/${id}`, method: 'put', data }) }
export function deleteSaleAnchor(id) { return request({ url: `/api/v1/sale/anchor/${id}`, method: 'delete' }) }
export function getAdminSaleAnchorList(params) { return request({ url: '/api/v1/sale/anchor/admin', method: 'get', params }) }

export function getOperatorList(params) { return request({ url: '/api/v1/operator', method: 'get', params }) }
export function createOperator(data) { return request({ url: '/api/v1/operator', method: 'post', data }) }
export function updateOperator(id, data) { return request({ url: `/api/v1/operator/${id}`, method: 'put', data }) }
export function deleteOperator(id) { return request({ url: `/api/v1/operator/${id}`, method: 'delete' }) }

export function getShopList(params) { return request({ url: '/api/v1/shop', method: 'get', params }) }
export function createShop(data) { return request({ url: '/api/v1/shop', method: 'post', data }) }
export function tidyShop(id, data) { return request({ url: `/api/v1/shop/tidy/${id}`, method: 'post', data }) }
export function updateShop(id, data) { return request({ url: `/api/v1/shop/${id}`, method: 'put', data }) }
export function deleteShop(id) { return request({ url: `/api/v1/shop/${id}`, method: 'delete' }) }

export function getSaleMemberList(params) { return request({ url: '/api/v1/sale/member', method: 'get', params }) }
export function createSaleMember(data) { return request({ url: '/api/v1/sale/member', method: 'post', data }) }
export function updateSaleMember(id, data) { return request({ url: `/api/v1/sale/member/${id}`, method: 'put', data }) }
export function deleteSaleMember(id) { return request({ url: `/api/v1/sale/member/${id}`, method: 'delete' }) }

export function getSaleList(params) { return request({ url: '/api/v1/sale', method: 'get', params }) }
export function getSaleStatistics(params) { return request({ url: '/api/v1/sale/statistics', method: 'get', params }) }
export function createSale(data) { return request({ url: '/api/v1/sale', method: 'post', data }) }
export function updateSale(id, data) { return request({ url: `/api/v1/sale/${id}`, method: 'put', data }) }
export function deleteSale(id) { return request({ url: `/api/v1/sale/${id}`, method: 'delete' }) }

export function getSaleRemittanceList(params) { return request({ url: '/api/v1/sale/remittance', method: 'get', params }) }
export function createSaleRemittance(data) { return request({ url: '/api/v1/sale/remittance', method: 'post', data }) }
export function updateSaleRemittance(id, data) { return request({ url: `/api/v1/sale/remittance/${id}`, method: 'put', data }) }
export function deleteSaleRemittance(id) { return request({ url: `/api/v1/sale/remittance/${id}`, method: 'delete' }) }

export function getSaleWeeksPerformanceList(params) { return request({ url: '/api/v1/sale/weeksPerformance', method: 'get', params }) }
export function createSaleWeeksPerformance(data) { return request({ url: '/api/v1/sale/weeksPerformance', method: 'post', data }) }
export function updateSaleWeeksPerformance(id, data) { return request({ url: `/api/v1/sale/weeksPerformance/${id}`, method: 'put', data }) }
export function deleteSaleWeeksPerformance(id) { return request({ url: `/api/v1/sale/weeksPerformance/${id}`, method: 'delete' }) }

export function getSaleMonthPerformanceList(params) { return request({ url: '/api/v1/sale/monthPerformance', method: 'get', params }) }
export function createSaleMonthPerformance(data) { return request({ url: '/api/v1/sale/monthPerformance', method: 'post', data }) }
export function updateSaleMonthPerformance(id, data) { return request({ url: `/api/v1/sale/monthPerformance/${id}`, method: 'put', data }) }
export function deleteSaleMonthPerformance(id) { return request({ url: `/api/v1/sale/monthPerformance/${id}`, method: 'delete' }) }

export function getSalePerformanceList(params) { return request({ url: '/api/v1/sale/performance', method: 'get', params }) }
export function createSalePerformance(data) { return request({ url: '/api/v1/sale/performance', method: 'post', data }) }
export function updateSalePerformance(id, data) { return request({ url: `/api/v1/sale/performance/${id}`, method: 'put', data }) }
export function deleteSalePerformance(id) { return request({ url: `/api/v1/sale/performance/${id}`, method: 'delete' }) }

export function getSaleInventory(params) { return request({ url: '/api/v1/sale/inventory', method: 'get', params }) }
export function getSaleStatisticsDay(params) { return request({ url: '/api/v1/sale/statistics/day', method: 'get', params }) }
export function getSaleStatisticsForDay(params) { return request({ url: '/api/v1/sale/statistics/forDay', method: 'get', params }) }
export function getSaleGoodsGroup(params) { return request({ url: '/api/v1/sale/goodsGroup', method: 'get', params }) }
export function getSaleStatisticsDayDetail(params) { return request({ url: '/api/v1/sale/statistics/day/detail', method: 'get', params }) }

export function getGiftList(params) { return request({ url: '/api/v1/gift', method: 'get', params }) }
export function createGift(data) { return request({ url: '/api/v1/gift', method: 'post', data }) }
export function updateGift(id, data) { return request({ url: `/api/v1/gift/${id}`, method: 'put', data }) }
export function deleteGift(id) { return request({ url: `/api/v1/gift/${id}`, method: 'delete' }) }

export function getDistributionList(params) { return request({ url: '/api/v1/sale/distribution', method: 'get', params }) }
export function createDistribution(data) { return request({ url: '/api/v1/sale/distribution', method: 'post', data }) }
export function updateDistribution(id, data) { return request({ url: `/api/v1/sale/distribution/${id}`, method: 'put', data }) }
export function deleteDistribution(id) { return request({ url: `/api/v1/sale/distribution/${id}`, method: 'delete' }) }

export function getDistributionStockOutList(params) { return request({ url: '/api/v1/sale/distributionStockOut', method: 'get', params }) }
export function createDistributionStockOut(data) { return request({ url: '/api/v1/sale/distributionStockOut', method: 'post', data }) }
export function updateDistributionStockOut(id, data) { return request({ url: `/api/v1/sale/distributionStockOut/${id}`, method: 'put', data }) }
export function deleteDistributionStockOut(id) { return request({ url: `/api/v1/sale/distributionStockOut/${id}`, method: 'delete' }) }

export function getDistributionReturnList(params) { return request({ url: '/api/v1/sale/distributionReturn', method: 'get', params }) }
export function createDistributionReturn(data) { return request({ url: '/api/v1/sale/distributionReturn', method: 'post', data }) }
export function updateDistributionReturn(id, data) { return request({ url: `/api/v1/sale/distributionReturn/${id}`, method: 'put', data }) }
export function deleteDistributionReturn(id) { return request({ url: `/api/v1/sale/distributionReturn/${id}`, method: 'delete' }) }

export function getGiftWarehousList(params) { return request({ url: '/api/v1/gift/warehous', method: 'get', params }) }
export function takeGiftInventory(params) { return request({ url: '/api/v1/gift/warehous/inventory', method: 'get', params }) }
export function createGiftWarehous(data) { return request({ url: '/api/v1/gift/warehous', method: 'post', data }) }
export function updateGiftWarehous(id, data) { return request({ url: `/api/v1/gift/warehous/${id}`, method: 'put', data }) }
export function deleteGiftWarehous(id) { return request({ url: `/api/v1/gift/warehous/${id}`, method: 'delete' }) }

export function getRequisitionList(params) { return request({ url: '/api/v1/requisition', method: 'get', params }) }
export function getRequisitionAnchorList(params) { return request({ url: '/api/v1/requisition/anchor', method: 'get', params }) }
export function createRequisition(data) { return request({ url: '/api/v1/requisition', method: 'post', data }) }
export function updateRequisition(id, data) { return request({ url: `/api/v1/requisition/${id}`, method: 'put', data }) }
export function deleteRequisition(id) { return request({ url: `/api/v1/requisition/${id}`, method: 'delete' }) }

/* 商品成本配置 */
export function getProfit(params) { return request({ url: `/api/v1/sale/profit`, method: 'get', params }) }
export function addProfit(data) { return request({ url: `/api/v1/sale/profit`, method: 'post', data }) }
export function upProfit(id, data) { return request({ url: `/api/v1/sale/profit/${id}`, method: 'put', data }) }
export function delProfit(id) { return request({ url: `/api/v1/sale/profit/${id}`, method: 'delete' }) }
export function addXlsxBatch(data) { return request({ url: `/api/v1/sale/profit/batch`, method: 'post', data }) }


export function getSaleFinancialStatements(params) { return request({ url: `/api/v1/sale/financial/statement`, method: 'get', params }) }
export function addSaleFinancialStatements(data) { return request({ url: `/api/v1/sale/sale/financial/statement`, method: 'post', data }) }
export function upSaleFinancialStatements(id, data) { return request({ url: `/api/v1/sale/financial/statement/${id}`, method: 'put', data }) }
export function delSaleFinancialStatements(id) { return request({ url: `/api/v1/sale/financial/statement/${id}`, method: 'delete' }) }
export function addSaleFinancialStatementsBatch(data) { return request({ url: `/api/v1/sale/financial/statement/batch`, method: 'post', data }) }

/* 经销商品成本配置 */
export function getDistributionProfit(params) { return request({ url: `/api/v1/sale/distributionProfit`, method: 'get', params }) }
export function addDistributionProfit(data) { return request({ url: `/api/v1/sale/distributionProfit`, method: 'post', data }) }
export function upDistributionProfit(id, data) { return request({ url: `/api/v1/sale/distributionProfit/${id}`, method: 'put', data }) }
export function delDistributionProfit(id) { return request({ url: `/api/v1/sale/distributionProfit/${id}`, method: 'delete' }) }
export function addDistributionXlsxBatch(data) { return request({ url: `/api/v1/sale/distributionProfit/batch`, method: 'post', data }) }

/* 销售利润分析 */
export function getSaleProfitDay(params) { return request({ url: `/api/v1/sale/saleProfitDay/day`, method: 'get', params }) }
export function addSaleProfitDay(data) { return request({ url: `/api/v1/sale/saleProfitDay/day`, method: 'post', data }) }
export function upSaleProfitDay(id, data) { return request({ url: `/api/v1/sale/saleProfitDay/day/${id}`, method: 'put', data }) }
export function delSaleProfitDay(id) { return request({ url: `/api/v1/sale/saleProfitDay/day/${id}`, method: 'delete' }) }

/* 广告成本配置 */
export function getSaleCost(params) { return request({ url: `/api/v1/sale/cost`, method: 'get', params }) }
export function addSaleCost(data) { return request({ url: `/api/v1/sale/cost`, method: 'post', data }) }
export function upSaleCost(id, data) { return request({ url: `/api/v1/sale/cost/${id}`, method: 'put', data }) }
export function delSaleCost(id) { return request({ url: `/api/v1/sale/cost/${id}`, method: 'delete' }) }
